import React from 'react'
import injectSheet from 'react-jss'
import { Image, LayoutMagnifier } from '../../'

const OptionGroupElements = (props) => {
  const {
    classes,
    node,
    compareOption,
  } = props

  return (
    <div className={`${classes.elementContainer}`}>
      {node && node.elements.map((element, index) => (
        <div
          key={`optionGroup-${element.title}`}
          className={`${classes.element} width-${node.elements.length}`}
          // style={{ width: `${100 / node.elements.length}%` }}
        >
          <div className={`${classes.titleContainer}`}>
            <h4>{element.title}</h4>
            {(element.images && Array.isArray(element.images)) && (
              <LayoutMagnifier
                index={index}
                node={node.parent}
                tip={compareOption ? 'Geschoss vergleichen' : 'Bild vergrössern'}
              />
            )}
          </div>
          <p>{element.description}</p>
          {(element.images && Array.isArray(element.images)) && (
            <div className={`${classes.imageContainer}`}>
              <Image
                src={element.images[0]}
                alt={element.title}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

const styles = theme => ({
  elementContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  element: {
    width: '100%',
    [theme.media.medium]: {
      width: `${100 / 2}%`,
      '&:nth-of-type(2)': {
        borderLeft: `2px solid ${theme.colors.secondary_3a}`,
      },
      '&:nth-of-type(3)': {
        width: '100%',
      },
      '&.width-1': {
        width: '100%',
      },
    },
    [theme.media.large]: {
      width: `${100 / 3}%`,
      '&:nth-of-type(3)': {
        width: `${100 / 3}%`,
        borderLeft: `2px solid ${theme.colors.secondary_3a}`,
      },
      '&.width-2': {
        width: `${100 / 2}%`,
      },
    },
    padding: `0 ${theme.sizes.gutter / 2}px`,
    margin: `${theme.sizes.gutter / 2}px 0`,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  imageContainer: {
    height: `${theme.sizes.layoutImage}px`,
  },
  buttonContainer: {
    paddingTop: `${theme.sizes.gutter}px`,
    display: 'flex',
    justifyContent: 'center',
  },
})

export default injectSheet(styles)(OptionGroupElements)



// WEBPACK FOOTER //
// ./src/modules/core/components/optionGroupElements.jsx